// extracted by mini-css-extract-plugin
export default {"menu":"NavBar_menu__w5T46","menuItem":"NavBar_menuItem__uF+C1"};